export default {
  'clocks': [
    'clock0800_1000',
    'clock1000_1200',
    'clock1300_1500',
    'clock1500_1700'
  ],
  'permanentRequiredFields': [
    'Salutation',
    'RequestInterest',
    'FirstName',
    'LastName',
    'Email',
    'State'
  ],
  'requiredFields': {
    'cooperation': [
      'PostalCode',
      'Company',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'press': [
      'Email'
    ]
  }

}
